import { createFileRoute } from '@tanstack/react-router'
import { League } from '@/features/league/league'

export const Route = createFileRoute('/_app/league')({ component: LeaguePage })

function LeaguePage() {
  const { me } = Route.useRouteContext()
  return <League impersonating={me.impersonating} />
}
